import React from "react";
import GeneralMUIDialog from "../GeneralMUIDialog/GeneralMUIDialog";
import QuickApplyForm from "./QuickApplyForm";

export default function QuickApplyModal({
  open,
  setOpen,
  targetJob = null,
  fetchDetails = () => {},
  setJobsList = () => {},
}) {
  return (
    <>
      <GeneralMUIDialog
        open={open}
        setOpen={setOpen}
        title="Quick Apply"
        showActionButton={false}
        maxWidth="md"
        disableClose={true}
        content={
          <QuickApplyForm
            job={targetJob}
            handleNavigateBack={() => {
              setOpen(false);
            }}
            fetchDetails={fetchDetails}
            setJobsList={setJobsList}
          />
        }
        showCloseButton={false}
      />
    </>
  );
}
